import React from 'react'

import {
  B5,
  Icon,
  SH3,
  Stack,
  XStack,
  YStack,
  colors,
} from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import { IPressableCtaWithIcon } from '../utils/interface'

export const PressableCtaWithIcon: React.FC<IPressableCtaWithIcon> = ({
  leftIcon,
  rightIcon,
  onPress,
  heading,
  subHeading,
  eventName,
  eventPayload,
  headingColor = colors.primary[150],
}) => {
  return (
    <Pressable
      onPress={onPress}
      eventName={eventName}
      eventPayload={eventPayload}
      className="bg-white"
    >
      <XStack className="border-grays-20 w-full items-center justify-between border-b-2 bg-white p-3">
        <XStack className="flex-1 items-center">
          <Stack className="mr-4/2">
            {leftIcon || (
              <Icon color={colors.primary[200]} type="QuestionMarkOutlined" />
            )}
          </Stack>
          <YStack className="flex-1">
            <SH3 style={{ color: headingColor }}>{heading}</SH3>
            <B5 className="text-grays-70 flex-1">{subHeading}</B5>
          </YStack>
        </XStack>
        <Stack>
          {rightIcon || <Icon color={colors.primary[200]} type="ArrowRight" />}
        </Stack>
      </XStack>
    </Pressable>
  )
}
